<template>
  <div>
    <v-card class="main-card">
      <v-card-title class="screen-title">
        <span>Hub&Spoke接続一覧</span>
        <manual-button path="/nwco-hubspoke/" />
      </v-card-title>
      <v-card-text class="pa-2" v-if="isLoaded">
        <v-row no-gutters>
          <v-col class="text-right mb-4">
            <v-btn color="primary" :href="downloadUrl" download
              >一覧ダウンロード</v-btn
            >
          </v-col>
        </v-row>
        <div class="d-flex flex-row justify-end mb-2">
          <v-btn color="primary" @click="load">一覧更新</v-btn>
        </div>
        <app-table
          :fields="hubAndSpoke.fields"
          :items="hubAndSpoke.items"
          v-model:table-sort-by="hubAndSpoke.sortBy"
          primary-key="hubSpokeSeq"
          sticky-header="50vh"
          :tr-class="() => undefined"
        >
          <!-- Hub側V番号 -->
          <template #cell(hubVNumber)="data">
            {{ $filter.emptyTo(data.value, "-") }}
          </template>

          <!-- Spoke側V番号 -->
          <template #cell(spokeVNumber)="data">
            {{ $filter.emptyTo(data.value, "-") }}
          </template>

          <!-- 状態 -->
          <template #cell(hubSpokeStatus)="data">
            {{ $filter.enumTo(data.value, "hubSpokeStatus") }}
          </template>
          <!-- 申請日時 -->
          <template #cell(requestDateTime)="data">
            {{ $filter.datetime(data.value) }}
          </template>
          <!-- 承認日時 -->
          <template #cell(approvalDateTime)="data">
            <template
              v-if="
                data.item.approvalDateTime &&
                (data.item.hubSpokeStatus === 'COMPLETE' ||
                  data.item.hubSpokeStatus === 'DISCONNECTED')
              "
            >
              {{ $filter.datetime(data.value) }}
            </template>
            <template v-else>-</template>
          </template>
        </app-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { HubSpokeInfo } from "@/apis/HubAndSpokeApi";
import type { AppTableHeader, SortItem } from "@/components/AppTable.vue";

export default defineComponent({
  name: "HubAndSpokeList",
  data() {
    return {
      hubAndSpoke: {
        sortBy: {
          key: "requestDateTime",
          order: "desc",
        } as SortItem,
        fields: HubAndSpokeFields,
        items: [] as HubSpokeInfo[],
      },
      // 初期通信完了フラグ
      isLoaded: false,
      // download用URL
      downloadUrl: this.$api.hubAndSpoke.getCsvHubAndSpokeURL(),
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      this.hubAndSpoke.items = await this.$api.hubAndSpoke.getHubAndSpoke();
    },
  },
});

// 列のデータ
const HubAndSpokeFields = [
  {
    key: "hubVNumber",
    title: "Hub側V番号",
    width: "115px",
  },
  {
    key: "hubVpnVnCode",
    title: "Hub側VPN/VNコード",
    width: "183px",
  },
  {
    key: "spokeVNumber",
    title: "Spoke側V番号",
    width: "131px",
  },
  {
    key: "spokeVpnVnCode",
    title: "Spoke側VPN/VNコード",
    width: "197px",
  },
  {
    key: "publicVpnCode",
    title: "広報先VPNコード",
    width: "154px",
  },
  {
    key: "hubSpokeStatus",
    title: "状態",
    width: "119px",
  },
  {
    key: "requestDateTime",
    title: "申請日時",
    width: "183px",
  },
  {
    key: "approvalDateTime",
    title: "承認日時",
    width: "183px",
  },
] as AppTableHeader<HubSpokeInfo>[];
</script>
